import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {ReportTemplateColumn} from '../../interfaces/ReportTemplateColumn';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';

@Injectable()
export class ReportTemplateColumnService {

  protected route = 'report-template';
  protected subRoute = 'template-column';

  constructor(private http: AuthHttp) {}

  public get(reportTemplateId: number): Promise<ReportTemplateColumn[]> {
    return this.http.get(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.subRoute}`).map((res) => res.json()).toPromise();
  }

  public create(reportTemplateId: number, reportTemplateColumn: ReportTemplateColumn) {
    return this.http.post(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.subRoute}`, reportTemplateColumn)
      .map((res) => res.json()).toPromise();
  }

  public update(reportTemplateId: number, reportTemplateColumn: ReportTemplateColumn) {
    return this.http
      .put(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.subRoute}/${reportTemplateColumn.id}`, reportTemplateColumn)
      .map((res) => res.json()).toPromise();
  }

  public updateMany(reportTemplateId: number, reportTemplateColumns: ReportTemplateColumn[]) {
    return this.http
      .put(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.subRoute}`, reportTemplateColumns)
      .toPromise();
  }

  public delete(reportTemplateId: number, id) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.subRoute}/${id}`)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/services/report-template-column/report-template-column.service.ts